import { createFileRoute } from '@tanstack/react-router';
import { CustomerSettingsPage } from '@/features/crm/pages/customer-settings-page';

const TABS = ['code', 'sources', 'tags', 'loyalty'] as const;

export const Route = createFileRoute('/_app/settings/customers')({
  validateSearch: (s: Record<string, unknown>): { tab?: (typeof TABS)[number] } => ({
    tab: TABS.find((t) => t === s.tab),
  }),
  component: CustomerSettingsPage,
});
